import React from "react";

function CustomTextField({ placeholder, id, name, register, rules }) {
  return (
    <div className="bg-white  h-[130px] max-h-[140px] my-2 w-full">
      <textarea
        className="w-full h-full outline-0 resize-none py-2 border focus:border-[1.5px] border-[#EDEDED] px-4 focus:border-LightGreen rounded transition-all ease-in duration-200"
        placeholder={placeholder}
        id={id}
        name={name}
        {...register(name, rules)}
      />
    </div>
  );
}
export default CustomTextField;
